const CHAT_ENTRY = {
    global: 'global',
    customerService: 'customerService',
    footer: 'footer',
    resume: 'resume',
    bccPlaceHolderApp: 'customerServiceChatApp',
    fraudErrCheckout: 'fraudErrCheckout',
    authenticate: 'AUTHENTICATED',
    timeOut: 'TIME_OUT'
};

const PROACTIVE_CHAT = {
    truncateTextLength: 50
};

export {
    CHAT_ENTRY, PROACTIVE_CHAT
};
